import {Stage, Shape, BlurFilter} from '@createjs/easeljs'
import {TweenMax} from 'gsap'

function range (min, max) {
  return min + (max - min) * Math.random()
}

function round (num, precision) {
  const decimal = Math.pow(10, precision)
  return Math.round(decimal * num) / decimal
}

function weightedRange (to, from, decimalPlaces, weightedRange, weightStrength) {
  if (typeof from === 'undefined' || from === null) {
    from = 0
  }
  if (typeof decimalPlaces === 'undefined' || decimalPlaces === null) {
    decimalPlaces = 0
  }
  if (typeof weightedRange === 'undefined' || weightedRange === null) {
    weightedRange = 0
  }
  if (typeof weightStrength === 'undefined' || weightStrength === null) {
    weightStrength = 0
  }

  let ret
  if (to === from) {
    return (to)
  }

  if (weightedRange && Math.random() <= weightStrength) {
    ret = round(Math.random() * (weightedRange[1] - weightedRange[0]) + weightedRange[0], decimalPlaces)
  } else {
    ret = round(Math.random() * (to - from) + from, decimalPlaces)
  }
  return (ret)
}

class Blinks {
  canvas_id
  stage
  totalWidth
  totalHeight
  compositeStyle
  particleSettings
  particleArray
  lights
  blurFilter

  constructor (canvas_id, options) {
    this.canvas_id = canvas_id
    this.stage = new Stage(canvas_id)
    this.totalWidth = this.canvasWidth = document.getElementById(canvas_id).width = document.getElementById(canvas_id).offsetWidth
    this.totalHeight = this.canvasHeight = document.getElementById(canvas_id).height = document.getElementById(canvas_id).offsetHeight
    this.compositeStyle = 'lighter'

    this.particleSettings = [
      {
        id: 'small',
        num: (options && options.settings && options.settings.small && options.settings.small.num) || 20,
        fromX: (options && options.settings && options.settings.small && options.settings.small.fromX) || 0,
        toX: this.totalWidth,
        ballwidth: (options && options.settings && options.settings.small && options.settings.small.ballwidth) || 3,
        alphamax: (options && options.settings && options.settings.small && options.settings.small.alphamax) || .4,
        areaHeight: (options && options.settings && options.settings.small && options.settings.small.areaHeight) || .5,
        color: (options && options.settings && options.settings.small && options.settings.small.color) || '#FFFD91',
        fill: (options && options.settings && options.settings.small && options.settings.small.fill) || false
      },
      {
        id: 'medium',
        num: (options && options.settings && options.settings.medium && options.settings.medium.num) || 50,
        fromX: (options && options.settings && options.settings.medium && options.settings.medium.fromX) || 0,
        toX: this.totalWidth,
        ballwidth: (options && options.settings && options.settings.medium && options.settings.medium.ballwidth) || 6,
        alphamax: (options && options.settings && options.settings.medium && options.settings.medium.alphamax) || 0.3,
        areaHeight: (options && options.settings && options.settings.medium && options.settings.medium.areaHeight) || 1,
        color: (options && options.settings && options.settings.medium && options.settings.medium.color) || '#FFFD91',
        fill: (options && options.settings && options.settings.medium && options.settings.medium.fill) || true
      },
      {
        id: 'large',
        num: (options && options.settings && options.settings.large && options.settings.large.num) || 50,
        fromX: (options && options.settings && options.settings.large && options.settings.large.fromX) || 0,
        toX: this.totalWidth,
        ballwidth: (options && options.settings && options.settings.large && options.settings.large.ballwidth) || 28,
        alphamax: (options && options.settings && options.settings.large && options.settings.large.alphamax) || 0.2,
        areaHeight: (options && options.settings && options.settings.large && options.settings.large.areaHeight) || 1,
        color: (options && options.settings && options.settings.large && options.settings.large.color) || '#FFFD91',
        fill: (options && options.settings && options.settings.large && options.settings.large.fill) || true
      }
    ]
    this.particleArray = []
    this.lights = [
      {
        ellipseWidth: (options && options.lights && options.lights.length > 0 && options.lights[0].ellipseWidth) || 400,
        ellipseHeight: (options && options.lights && options.lights.length > 0 && options.lights[0].ellipseHeight) || 100,
        alpha: (options && options.lights && options.lights.length > 0 && options.lights[0].alpha) || 0.3,
        offsetX: (options && options.lights && options.lights.length > 0 && options.lights[0].offsetX) || 0,
        offsetY: (options && options.lights && options.lights.length > 0 && options.lights[0].offsetY) || 0,
        color: (options && options.lights && options.lights.length > 0 && options.lights[0].color) || '#FFFFFF'
      },
      {
        ellipseWidth: (options && options.lights && options.lights.length > 1 && options.lights[1].ellipseWidth) || 350,
        ellipseHeight: (options && options.lights && options.lights.length > 1 && options.lights[1].ellipseHeight) || 250,
        alpha: (options && options.lights && options.lights.length > 1 && options.lights[1].alpha) || 0.3,
        offsetX: (options && options.lights && options.lights.length > 1 && options.lights[1].offsetX) || -50,
        offsetY: (options && options.lights && options.lights.length > 1 && options.lights[1].offsetY) || 300,
        color: (options && options.lights && options.lights.length > 1 && options.lights[1].color) || '#000000'
      },
      {
        ellipseWidth: (options && options.lights && options.lights.length > 2 && options.lights[2].ellipseWidth) || 100,
        ellipseHeight: (options && options.lights && options.lights.length > 2 && options.lights[2].ellipseHeight) || 80,
        alpha: (options && options.lights && options.lights.length > 2 && options.lights[2].alpha) || 0.2,
        offsetX: (options && options.lights && options.lights.length > 2 && options.lights[2].offsetX) || 80,
        offsetY: (options && options.lights && options.lights.length > 2 && options.lights[2].offsetY) || 250,
        color: (options && options.lights && options.lights.length > 2 && options.lights[2].color) || '#FFFD91'
      }
    ]

    this.stage.compositeOperation = this.compositeStyle

    this.drawBgLight()
    this.drawParticles()
  }

  render = () => {
    this.stage.update()
  }

  resize = () => {
    this.totalWidth = this.canvasWidth = document.getElementById(this.canvas_id).width = document.getElementById(this.canvas_id).offsetWidth
    this.totalHeight = this.canvasHeight = document.getElementById(this.canvas_id).height = document.getElementById(this.canvas_id).offsetHeight
    this.render()

    for (let i = 0, length = this.particleArray.length; i < length; i++) {
      this.applySettings(this.particleArray[i], 0, this.totalWidth, this.particleArray[i].areaHeight)
    }

    for (let j = 0, len = this.lights.length; j < len; j++) {
      this.lights[j].elem.initY = this.totalHeight / 2 + this.lights[j].offsetY
      this.lights[j].elem.initX = this.totalWidth / 2 + this.lights[j].offsetX
      TweenMax.to(this.lights[j].elem, .5, {x: this.lights[j].elem.initX, y: this.lights[j].elem.initY})
    }
  }

  drawBgLight () {
    let light
    let bounds
    let blurFilter
    for (let i = 0, len = this.lights.length; i < len; i++) {
      light = new Shape()
      light.graphics.beginFill(this.lights[i].color).drawEllipse(0, 0, this.lights[i].ellipseWidth, this.lights[i].ellipseHeight)
      light.regX = this.lights[i].ellipseWidth / 2
      light.regY = this.lights[i].ellipseHeight / 2
      light.y = light.initY = this.totalHeight / 2 + this.lights[i].offsetY
      light.x = light.initX = this.totalWidth / 2 + this.lights[i].offsetX

      blurFilter = new BlurFilter(this.lights[i].ellipseWidth, this.lights[i].ellipseHeight, 1)
      bounds = blurFilter.getBounds()
      light.filters = [blurFilter]
      light.cache(bounds.x - this.lights[i].ellipseWidth / 2, bounds.y - this.lights[i].ellipseHeight / 2, bounds.width * 2, bounds.height * 2)
      light.alpha = this.lights[i].alpha

      light.compositeOperation = 'screen'
      this.stage.addChildAt(light, 0)

      this.lights[i].elem = light
    }

    TweenMax.fromTo(this.lights[0].elem, 10, {
      scaleX: 1.5,
      x: this.lights[0].elem.initX,
      y: this.lights[0].elem.initY
    }, {yoyo: true, repeat: -1, ease: Power1.easeInOut, scaleX: 2, scaleY: 0.7})
    TweenMax.fromTo(this.lights[1].elem, 12, {
      x: this.lights[1].elem.initX,
      y: this.lights[1].elem.initY
    }, {
      delay: 5,
      yoyo: true,
      repeat: -1,
      ease: Power1.easeInOut,
      scaleY: 2,
      scaleX: 2,
      y: this.totalHeight / 2 - 50,
      x: this.totalWidth / 2 + 100
    })
    TweenMax.fromTo(this.lights[2].elem, 8, {
      x: this.lights[2].elem.initX,
      y: this.lights[2].elem.initY
    }, {
      delay: 2,
      yoyo: true,
      repeat: -1,
      ease: Power1.easeInOut,
      scaleY: 1.5,
      scaleX: 1.5,
      y: this.totalHeight / 2,
      x: this.totalWidth / 2 - 200
    })
  }

  drawParticles () {
    for (let i = 0, len = this.particleSettings.length; i < len; i++) {
      const ball = this.particleSettings[i]

      let circle
      for (let s = 0; s < ball.num; s++) {
        circle = new Shape()
        if (ball.fill) {
          circle.graphics.beginFill(ball.color).drawCircle(0, 0, ball.ballwidth)
          this.blurFilter = new BlurFilter(ball.ballwidth / 2, ball.ballwidth / 2, 1)
          circle.filters = [this.blurFilter]
          const bounds = this.blurFilter.getBounds()
          circle.cache(-50 + bounds.x, -50 + bounds.y, 100 + bounds.width, 100 + bounds.height)
        } else {
          circle.graphics.beginStroke(ball.color).setStrokeStyle(1).drawCircle(0, 0, ball.ballwidth)
        }

        circle.alpha = range(0, 0.1)
        circle.alphaMax = ball.alphamax
        circle.distance = ball.ballwidth * 2
        circle.ballwidth = ball.ballwidth
        circle.flag = ball.id
        this.applySettings(circle, ball.fromX, ball.toX, ball.areaHeight)
        circle.speed = range(2, 10)
        circle.y = circle.initY
        circle.x = circle.initX
        circle.scaleX = circle.scaleY = range(0.3, 1)

        this.stage.addChild(circle)


        this.animateBall(circle)

        this.particleArray.push(circle)
      }
    }
  }

  applySettings = (circle, positionX, totalWidth, areaHeight) => {
    circle.speed = range(1, 3)
    circle.initY = weightedRange(0, this.totalHeight, 1, [this.totalHeight * (2 - areaHeight / 2) / 4, this.totalHeight * (2 + areaHeight / 2) / 4], 0.8)
    circle.initX = weightedRange(positionX, totalWidth, 1, [positionX + ((totalWidth - positionX)) / 4, positionX + ((totalWidth - positionX)) * 3 / 4], 0.6)
  }

  animateBall (ball) {
    const scale = range(0.3, 1)
    const xpos = range(ball.initX - ball.distance, ball.initX + ball.distance)
    const ypos = range(ball.initY - ball.distance, ball.initY + ball.distance)
    const speed = ball.speed
    TweenMax.to(ball, speed, {
      scaleX: scale,
      scaleY: scale,
      x: xpos,
      y: ypos,
      onComplete: this.animateBall,
      onCompleteParams: [ball],
      ease: Cubic.easeInOut
    })
    TweenMax.to(ball, speed / 2, {
      alpha: range(0.1, ball.alphaMax),
      onComplete: this.fadeout,
      onCompleteParams: [ball, speed]
    })
  }

  fadeout (ball, speed) {
    ball.speed = range(2, 10)
    TweenMax.to(ball, speed / 2, {alpha: 0})
  }
}

export default Blinks
